<template>
  <div v-if="!isMobile" class="home">
    <div class="home-header">
      <div class="home-banner hb-padding">
        <p class="hb-title">Ví bắc nam</p>
        <p class="hb-title margin-btm-huge ">Người bạn tài chính tận tâm của bạn</p>
        <p class="hb-text">Ví bắc nam là một ứng dụng chuyên nghiệp, cam kết cung cấp dịch vụ vay an toàn và hợp pháp cho người dùng.</p>
        <p class="hb-text">Chúng tôi luôn giữ vững phương châm "Người bạn tài chính tận tâm của bạn", nhằm giúp những người có nhu cầu vay vốn 
          nhanh chóng và tiện lợi nhận được số tiền cần thiết.</p>

        <!-- <div>
          <p class="hb-subtext">Tải ứng dụng ngay</p>
        </div>
        <img @click="toGP" class="google-button" src="../../assets/images/google-button.png" alt=""> -->
      </div>
    </div>
    <div class="home-content">
      <img class="app-bg" src="../../assets/images/app-bg.png" alt="">
      <div class="hc-right">
        <p class="font-40 text-color-black weight-bold margin-btm-huge">Dịch vụ vay</p>
        <p class="font-18 text-color-deepgray margin-btm-middle">Ví Bắc Nam cung cấp dịch vụ vay với hạn mức cao, phạm vi vay từ 1 triệu đến 40 triệu, đáp ứng nhu cầu vay của nhiều người dùng khác nhau. </p>
        <p class="font-18 text-color-deepgray margin-btm-middle">Đồng thời, chúng tôi cung cấp các lựa chọn kỳ hạn vay linh hoạt, từ ít nhất 120 ngày đến tối đa 365 ngày, giúp người dùng chọn kỳ hạn thanh toán phù hợp với tình hình tài chính của mình. </p>
        <p class="font-18 text-color-deepgray">Về lãi suất, chúng tôi cung cấp lãi suất tối đa không vượt quá 36%, và phí dịch vụ là 0%, đảm bảo người dùng được hưởng dịch vụ vay với chi phí thấp.</p>
      </div>
    </div>
    <div class="home-why">
      <p class="font-40 text-color-black weight-bold margin-btm-middle text-center">Yêu cầu vay</p>
      <p class="hw-width font-18 text-color-deepgray">
        <span>Để đảm bảo tính hợp pháp và an toàn cho dịch vụ vay, Ví bắc nam đặt ra các yêu cầu sau đối với người vay
        </span>
      </p>
      <div class="flex-between-wrap">
        <div class="hw-item">
          <div>
            <p class="font-32 m-bottom-row">Yêu cầu về độ tuổi</p>
            <p class="font-18 weight-bold">Trên 18 tuổi</p>
          </div>
          <div class="hw-icon1"></div>
        </div>
        <div class="hw-item">
          <div>
            <p class="font-32 m-bottom-row">Yêu cầu về quốc tịch</p>
            <p class="hwi-subtitle font-18 weight-bold">Là công dân Việt Nam</p>
          </div>
          <div class="hw-icon2"></div>
        </div>
        <div class="hw-item">
          <div>
            <p class="font-32 m-bottom-row">Tài khoản ngân hàng</p>
            <p class="hwi-subtitle font-18 weight-bold">Có tài khoản ngân hàng hợp lệ tại Việt Nam</p>
          </div>
          <div class="hw-icon3"></div>
        </div>
        <div class="hw-item">
          <div>
            <p class="font-32 m-bottom-row">Thu nhập ổn định</p>
            <p class="hwi-subtitle font-18 weight-bold">Có nguồn thu nhập ổn định</p>
          </div>
          <div class="hw-icon4"></div>
        </div>
      </div>
    </div>
    <div class="home-condition">
      <p class="font-40 text-color-black weight-bold margin-btm-middle text-center">Các bước đăng ký</p>
      <p class="hw-width font-18 text-color-deepgray text-center">Vay tiền dễ dàng chỉ trong 3 bước</p>
      <div class="flex-between">
        <div class="hc-item">
          <img class="hc-icon" src="../../assets/images/hc-icon1.png" alt="">
          <p class="font-32">Xác minh thông tin</p>
        </div>
        <div class="hc-item">
          <img class="hc-icon" src="../../assets/images/hc-icon2.png" alt="">
          <p class="font-32">Nhận hạn mức</p>
        </div>
        <div class="hc-item">
          <img class="hc-icon" src="../../assets/images/hc-icon3.png" alt="">
          <p class="font-32">Rút tiền về tài khoản</p>
        </div>
      </div>
    </div>
    <div class="home-adv">
      <div class="ha-body">
        <p class="font-40 text-color-black weight-bold margin-btm-module text-center">Ưu điểm sản phẩm</p>
        <div class="flex-end relative">
          <div class="ha-text">
            <p class="flex-center margin-btm-huge" :class="[defaultNum == 1 ? 'hat-item-light' : 'hat-item']">
              <span class="num1">1</span>
              <span class="text-color font-32">Đăng ký đơn giản, chỉ cần CCCD của bạn</span>
            </p>
            <p class="flex-center margin-btm-huge" :class="[defaultNum == 2 ? 'hat-item-light' : 'hat-item']">
              <span class="num1">2</span>
              <span class="text-color font-32">Duyệt vay siêu nhanh, giải ngân nhanh chóng</span>
            </p>
            <p class="flex-center" :class="[defaultNum == 3 ? 'hat-item-light' : 'hat-item']">
              <span class="num1">3</span>
              <span class="text-color font-32">Thương hiệu uy tín, an toàn và hợp pháp</span>
            </p>
          </div>
          <img class="ha-ad" src="../../assets/images/ha-ad.png" alt="">
        </div>
      </div>
    </div>
    <div class="home-footer">
      <p class="font-40 text-color-black weight-bold margin-btm-middle text-center">Liên hệ với chúng tôi</p>
      <p class="hf-width font-18 text-color-deepgray">
        <span>Ví bắc nam, người bạn tài chính tận tâm của bạn, luôn nỗ lực cung cấp trải nghiệm dịch vụ vay an toàn và
          tiện lợi nhất. Bất kể lúc nào, nếu bạn có bất kỳ câu hỏi hay nhu cầu nào, chúng tôi luôn sẵn sàng phục vụ bạn.
        </span>
      </p>
    </div>
  </div>
  <div v-else class="m-home">
    <div class="home-header">
      <div class="home-banner hb-padding">
        <p class="hb-title">Ví bắc nam</p>
        <p class="hb-title margin-btm">Người bạn tài chính tận tâm của bạn</p>
        <!-- <div>
          <p class="hb-subtext">Tải ứng dụng ngay</p>
        </div>
        <img @click="toGP" class="google-button" src="../../assets/images/google-button.png" alt=""> -->
      </div>
    </div>
    <p class="hb-text margin-top-middle">Ví bắc nam là một ứng dụng chuyên nghiệp, cam kết cung cấp dịch vụ vay an toàn và hợp pháp cho người dùng.</p>
    <p class="hb-text margin-btm-middle">Chúng tôi luôn giữ vững phương châm "Người bạn tài chính tận tâm của bạn", nhằm giúp những người có nhu cầu vay vốn 
      nhanh chóng và tiện lợi nhận được số tiền cần thiết.</p>
    <div class="home-content">
      <div class="text-center">
        <img class="app-bg" src="../../assets/images/app-bg.png" alt="">
      </div>
      <div class="hc-right">
        <p class="font-18 weight-bold margin-btm">Dịch vụ vay</p>
        <p class="font-12 text-color-deepgray m-bottom-row">Ví Bắc Nam cung cấp dịch vụ vay với hạn mức cao, phạm vi vay từ 1 triệu đến 40 triệu, đáp ứng nhu cầu vay của nhiều người dùng khác nhau. </p>
        <p class="font-12 text-color-deepgray m-bottom-row">Đồng thời, chúng tôi cung cấp các lựa chọn kỳ hạn vay linh hoạt, từ ít nhất 120 ngày đến tối đa 365 ngày, giúp người dùng chọn kỳ hạn thanh toán phù hợp với tình hình tài chính của mình. </p>
        <p class="font-12 text-color-deepgray">Về lãi suất, chúng tôi cung cấp lãi suất tối đa không vượt quá 36%, và phí dịch vụ là 0%, đảm bảo người dùng được hưởng dịch vụ vay với chi phí thấp.</p>
      </div>
    </div>
    <div class="home-why">
      <p class="font-18 weight-bold margin-btm-middle text-center">Yêu cầu vay</p>
      <p class="font-12 text-color-deepgray">Để đảm bảo tính hợp pháp và an toàn cho dịch vụ vay, Ví bắc nam đặt ra các
        yêu cầu sau đối với người vay</p>
      <div class="flex-between-wrap">
        <div class="hw-item">
          <div>
            <p class="font-18 m-bottom-row">Yêu cầu về độ tuổi</p>
            <p class="font-14 weight-bold">Trên 18 tuổi</p>
          </div>
          <div class="hw-icon1"></div>
        </div>
        <div class="hw-item">
          <div>
            <p class="font-18 m-bottom-row">Yêu cầu về quốc tịch</p>
            <p class="hwi-subtitle font-14 weight-bold">Là công dân Việt Nam</p>
          </div>
          <div class="hw-icon2"></div>
        </div>
        <div class="hw-item">
          <div>
            <p class="font-18 m-bottom-row">Tài khoản ngân hàng</p>
            <p class="hwi-subtitle font-14 weight-bold">Có tài khoản ngân hàng hợp lệ tại Việt Nam</p>
          </div>
          <div class="hw-icon3"></div>
        </div>
        <div class="hw-item">
          <div>
            <p class="font-18 m-bottom-row">Thu nhập ổn định</p>
            <p class="hwi-subtitle font-14 weight-bold">Có nguồn thu nhập ổn định</p>
          </div>
          <div class="hw-icon4"></div>
        </div>
      </div>
    </div>
    <div class="home-condition">
      <p class="font-18 weight-bold margin-btm-middle text-center">Các bước đăng ký</p>
      <p style="margin-bottom: 100px;" class="font-14 text-color-deepgray text-center">Vay tiền dễ dàng chỉ trong 3 bước
      </p>
      <div class="flex-center-center-columm">
        <div class="hc-item">
          <img class="hc-icon" src="../../assets/images/hc-icon1.png" alt="">
          <p class="font-20">Xác minh thông tin</p>
        </div>
        <div class="hc-item">
          <img class="hc-icon" src="../../assets/images/hc-icon2.png" alt="">
          <p class="font-20">Nhận hạn mức</p>
        </div>
        <div class="hc-item">
          <img class="hc-icon" src="../../assets/images/hc-icon3.png" alt="">
          <p class="font-20">Rút tiền về tài khoản</p>
        </div>
      </div>
    </div>
    <div class="home-adv">
      <div class="ha-body">
        <p class="font-18 weight-bold margin-btm-module text-center">Ưu điểm sản phẩm</p>
        <img class="ha-ad" src="../../assets/images/m-ha-ad.png" alt="">
        <div>
          <div class="ha-text">
            <p class="hat-item flex-center margin-btm-mini">
              <span class="num1">1</span>
              <span class="text-color font-14">Đăng ký đơn giản, chỉ cần CCCD của bạn</span>
            </p>
            <p class="hat-item flex-center margin-btm-mini">
              <span class="num1">2</span>
              <span class="text-color font-14">Duyệt vay siêu nhanh, giải ngân nhanh chóng</span>
            </p>
            <p class="hat-item flex-center">
              <span class="num1">3</span>
              <span class="text-color font-14">Thương hiệu uy tín, an toàn và hợp pháp</span>
            </p>
          </div>

        </div>
      </div>
    </div>
    <div class="home-footer">
      <p class="font-18 weight-bold margin-btm-middle text-center">Liên hệ với chúng tôi</p>
      <p class="font-12 text-color-deepgray">
        <span>Ví bắc nam, người bạn tài chính tận tâm của bạn, luôn nỗ lực cung cấp trải nghiệm dịch vụ vay an toàn và
          tiện lợi nhất. Bất kể lúc nào, nếu bạn có bất kỳ câu hỏi hay nhu cầu nào, chúng tôi luôn sẵn sàng phục vụ bạn.
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { def } from '@vue/shared';
import { set } from 'vue';

export default {
  props: {},
  components: {

  },
  data() {
    return {
      defaultNum: 1,
      setIn: null
    }
  },

  computed: {
  },

  created() {
  },
  async mounted() {
    this.setIn = setInterval(() => {
      this.defaultNum++;
      if (this.defaultNum > 3) {
        this.defaultNum = 1;
      }
    }, 2000)

  },
  destroyed() {
    clearInterval(this.setIn);
  },
  methods: {
    toGP() {
      // window.open("https://play.google.com/store/apps/details?id=com.vn.vayuytin");
    },
  }
}
</script>

<style lang="scss" scoped>
.home {
  margin-top: 80px;

  .hb-padding {
    padding-top: 100px;
    padding-left: 80px;
  }

  .home-banner {
    background: url('../../assets/images/banner-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 690px;
    color: #160F2D;
    padding: 140px 0 100px 100px;

    .hb-title {
      font-size: 40px;
      font-weight: bold;
    }

    .hb-text {
      width: 602px;
      font-size: 18px;
      margin-top: 10px;
      line-height: 160%;
    }

    .hb-subtext {
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      background-image: linear-gradient(262deg, #FFC56F 11%, #FF3B3B 93%);
      -webkit-background-clip: text;
      color: transparent;
      background-clip: text;
      margin-top: 40px;
    }

    .google-button {
      width: 131px;
      height: 45px;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  .home-content {
    padding: 46px 100px 46px 100px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #ffffff;

    .app-bg {
      width: 500px;
      height: 500px;
    }

    .hc-right {
      width: calc(100% - 560px);
    }
  }

  .home-why {
    padding: 100px;
    background: #FAFAFC;

    .hw-width {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 80px;

      span {
        width: 580px;
        text-align: center;
      }
    }

    .hw-item {
      background: url('../../assets/images/hw-border.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 610px;
      padding: 50px 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #3F3F3F;
      margin-top: 20px;
      cursor: pointer;

      .hw-icon1 {
        width: 80px;
        height: 80px;
        background: url('../../assets/images/hw-icon1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon2 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon3 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon4 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon4.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hwi-subtitle {
        color: #58585E;
      }
    }

    .hw-item:hover {
      background: linear-gradient(254deg, #FFC56F 11%, #FF3B3B 93%);
      border-radius: 22px;
      width: 610px;
      padding: 50px 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #3F3F3F;
      margin-top: 20px;
      color: #ffffff;
      cursor: pointer;
      box-shadow: 0px 10px 10px 0px rgba(159, 159, 159, 0.3);

      .hw-icon1 {
        width: 80px;
        height: 80px;
        background: url('../../assets/images/hw-icon-selected1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon2 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon-selected2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon3 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon-selected3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon4 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon-selected4.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hwi-subtitle {
        color: #ffffff;
      }
    }
  }

  .home-condition {
    padding: 100px 100px 140px 100px;
    background-color: #ffffff;
    color: #3F3F3F;

    .hw-width {
      margin-bottom: 100px;
    }

    .hc-item {
      width: 390px;
      height: 200px;
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #FAFAFC;
      cursor: pointer;
      position: relative;
      border-radius: 32px;
      color: #3F3F3F;

      &::after {
        content: '';
        position: absolute;
        right: -18px;
        top: 90px;
        border-left: 20px solid #FAFAFC;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
      }
    }

    .hc-item:hover {
      width: 390px;
      height: 200px;
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #FF4C3F;
      cursor: pointer;
      border-radius: 32px;
      color: #ffffff;

      &::after {
        content: '';
        position: absolute;
        right: -18px;
        top: 90px;
        border-left: 20px solid #FF4C3F;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
      }
    }

    .hc-icon {
      margin-top: -60px;
      width: 120px;
      height: 120px;
      margin-bottom: 20px;
    }
  }

  .home-adv {
    background-color: #ffffff;

    .ha-body {
      background: #FAFAFC;
      border-radius: 120px 120px 0 0;
      padding: 100px 100px 0 100px;
    }

    .ha-ad {
      width: 604px;
      height: 532px;
    }

    .ha-text {
      height: 532px;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .hat-item {
      cursor: pointer;

      .num1 {
        width: 60px;
        height: 60px;
        font-size: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #58585E;
        border: 2px solid #58585E;
        margin-right: 20px;
      }

      .text-color {
        color: #3F3F3F;
      }
    }

    .hat-item-light {
      .num1 {
        width: 60px;
        height: 60px;
        font-size: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #FFFFFF;
        background-color: #FF4C3F;
        border: 2px solid #FF4C3F;
        margin-right: 20px;
      }

      .text-color {
        color: #FF4C3F;
      }
    }

    // .hat-item:hover {
    //   .num1 {
    //     width: 60px;
    //     height: 60px;
    //     font-size: 32px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     border-radius: 50%;
    //     color: #FFFFFF;
    //     background-color: #FF4C3F;
    //     border: 1px solid #FF4C3F;
    //     margin-right: 20px;
    //   }

    //   .text-color {
    //     color: #FF4C3F;
    //   }
    // }
  }

  .home-footer {
    padding: 100px;
    background-color: #ffffff;

    .hf-width {
      width: 100%;
      display: flex;
      justify-content: center;

      span {
        width: 680px;
        text-align: center;
      }
    }
  }

}
</style>
<style lang="scss" scoped>
.m-home {

  .home-banner {
    background: url('../../assets/images/banner-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 160px;
    color: #160F2D;
    padding: 10px 0 10px 10px;

    .hb-title {
      font-size: 16px;
      font-weight: bold;
      margin-top: 16px;
    }

    .hb-subtext {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      background-image: linear-gradient(262deg, #FFC56F 11%, #FF3B3B 93%);
      -webkit-background-clip: text;
      color: transparent;
      background-clip: text;
      margin-top: 20px;
    }

    .google-button {
      width: 100px;
      height: 35px;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  .hb-text {
      font-size: 12px;
      padding: 10px 12px;
      line-height: 160%;
    }

  .home-content {
    padding: 10px 12px 16px 10px;
    background-color: #ffffff;

    .app-bg {
      width: 150px;
      height: 150px;
    }

  }

  .home-why {
    padding: 20px 12px;

    .hw-width {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 80px;

      span {
        width: 580px;
        text-align: center;
      }
    }

    .hw-item {
      background: url('../../assets/images/hw-border.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 100%;
      padding: 16px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #3F3F3F;
      margin-top: 20px;
      cursor: pointer;

      .hw-icon1 {
        width: 60px;
        height: 60px;
        background: url('../../assets/images/hw-icon1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon2 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon3 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon4 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon4.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hwi-subtitle {
        color: #58585E;
      }
    }

    .hw-item:hover {
      background: linear-gradient(254deg, #FFC56F 11%, #FF3B3B 93%);
      border-radius: 12px;
      width: 100%;
      padding: 16px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #3F3F3F;
      margin-top: 15px;
      color: #ffffff;
      cursor: pointer;
      box-shadow: 0px 10px 10px 0px rgba(159, 159, 159, 0.3);

      .hw-icon1 {
        width: 60px;
        height: 60px;
        background: url('../../assets/images/hw-icon-selected1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon2 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon-selected2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon3 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon-selected3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hw-icon4 {
        @extend .hw-icon1;
        background: url('../../assets/images/hw-icon-selected4.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .hwi-subtitle {
        color: #ffffff;
      }
    }
  }

  .home-condition {
    padding: 20px 12px;
    background-color: #ffffff;
    color: #3F3F3F;

    .hw-width {
      margin-bottom: 100px;
    }

    .hc-item {
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #FAFAFC;
      cursor: pointer;
      position: relative;
      border-radius: 16px;
      color: #3F3F3F;
      margin-bottom: 60px;
    }

    .hc-item:hover {
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #FF4C3F;
      cursor: pointer;
      border-radius: 16px;
      color: #ffffff;

    }

    .hc-icon {
      margin-top: -40px;
      width: 80px;
      height: 80px;
      margin-bottom: 10px;
    }
  }

  .home-adv {
    background-color: #ffffff;

    .ha-body {
      background: #FAFAFC;
      padding: 20px 12px 20px 12px;
    }

    .ha-ad {
      width: 100%;
    }

    .ha-text {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 20px 0;
    }

    .hat-item {
      cursor: pointer;

      .num1 {
        width: 20px;
        height: 20px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #58585E;
        border: 1px solid #58585E;
        margin-right: 10px;
      }

      .text-color {
        color: #3F3F3F;
      }
    }

    .hat-item:hover {
      .num1 {
        width: 20px;
        height: 20px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #FFFFFF;
        background-color: #FF4C3F;
        border: 1px solid #FF4C3F;
        margin-right: 10px;
      }

      .text-color {
        color: #FF4C3F;
      }
    }
  }

  .home-footer {
    padding: 20px 12px;
    background-color: #ffffff;

    .hf-width {
      width: 100%;
      display: flex;
      justify-content: center;

      span {
        width: 680px;
        text-align: center;
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/views/homePage/index.vue